import * as React from 'react';
import cn from 'classnames';
import { CloseClear, InfoDetails } from '../../../../Icons';
import { useTheme } from '../../../../theme';
const Content = ({ className, type, title, text, renderButton, onClose }) => {
    const { Snackbar: css } = useTheme('BaseComponents');
    return (React.createElement("div", { className: cn(css.wrapper, css[type], className) },
        React.createElement("div", { className: css.infoIcon }, InfoDetails),
        (title || text) && (React.createElement("div", { className: css.message },
            title && React.createElement("div", { className: css.title }, title),
            text && React.createElement("div", { className: css.text }, text))),
        renderButton,
        onClose && (React.createElement("div", { className: css.close, onClick: onClose }, CloseClear))));
};
export default Content;
